/** PURE_IMPORTS_START ._RangeObservable PURE_IMPORTS_END */
import { RangeObservable } from './RangeObservable';
export var range = RangeObservable.create;
//# sourceMappingURL=range.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/observable/range.js
// module id = 405
// module chunks = 0